/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ArtifactSharesResponse {
    getFixupPrototypeFunction() { return ArtifactSharesResponse.fixupPrototype; }

    static newInstance(model: Partial<ArtifactSharesResponse>): ArtifactSharesResponse {
        let obj = Object.assign(new ArtifactSharesResponse(), model);
        ArtifactSharesResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ArtifactSharesResponse>): ArtifactSharesResponse {
        if (!model) return null;
        return ArtifactSharesResponse.newInstance(<ArtifactSharesResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ArtifactSharesResponse) {
        if (!obj) return;

        models.ArtifactSharesResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ArtifactSharesResponse): boolean {
        Object.setPrototypeOf(obj, ArtifactSharesResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.shares) {
            for (let val of this.shares) {
                models.ArtifactShare.fixupPrototype(val);
            }
        }
    }

    /**
     * Active shares for this artifact
     */
    shares: Array<models.ArtifactShare>;

}
